<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}供应商</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">供应商基础信息</span>
          </div>
          <div class="">
            <el-row>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="供应商编号" prop="no">
                  <el-input disabled v-model="form.no" placeholder="系统自动生成供应商编号" style="width: 90%"></el-input>
                </el-form-item>
                <span class="viewText" v-else> 供应商编号:{{ form.no }}</span>
              </el-col>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="供应商名称" prop="name">
                  <el-input v-model="form.name" :disabled="!editMode" placeholder="请填写供应商名称" style="width: 90%"></el-input>
                </el-form-item>
                <span class="viewText" v-else> 供应商名称:{{ form.name }}</span>
              </el-col>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="供应商级别" prop="level">
                  <el-select v-model="form.level" :disabled="!editMode" placeholder="请选择级别" style="width: 90%">
                    <el-option v-for="item in LevelOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <span class="viewText" v-else> 供应商级别:{{ LevelOptions.find(item => item.id === form.level)?.name  }}</span>
              </el-col>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="供应商类型" prop="category1">
                  <el-select v-model="form.category1" :disabled="!editMode" multiple placeholder="请选择类型" @change="categoryChange" style="width: 90%">
                    <el-option v-for="item in SupplierCategoryOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <span class="viewText" v-else> 供应商类型:{{ form.category1 }}</span>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="联系人" prop="contactor">
                  <el-input v-model="form.contactor" :disabled="!editMode" placeholder="请填写联系人" style="width: 90%"></el-input>
                </el-form-item>
                <span class="viewText" v-else> 联系人:{{ form.contactor }}</span>
              </el-col>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="联系方式" prop="phone">
                  <el-input v-model="form.phone" :disabled="!editMode" placeholder="请填写联系方式" style="width: 90%"></el-input>
                </el-form-item>
                <span class="viewText" v-else> 联系方式:{{ form.phone }}</span>
              </el-col>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="产地信息" prop="countryId">
                  <Address style="width: 90%" :disabled="!editMode" :oldCountryId="form.countryId" :oldProvinceId="form.provinceId" :oldCityId="form.cityId" @change="getAddressData"></Address>
                </el-form-item>
                <span class="viewText" v-else> 产地信息:{{ form.countryId }}</span>
              </el-col>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="注册地址" prop="address">
                  <el-input v-model="form.address" :disabled="!editMode" placeholder="请填写详细地址" style="width: 90%"></el-input>
                </el-form-item>
                <span class="viewText" v-else> 注册地址:{{ form.address }}</span>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="统一社会信用代码" prop="creditCode">
                  <el-input v-model="form.creditCode" :disabled="!editMode" placeholder="请填写组织机构代码" style="width: 90%"></el-input>
                </el-form-item>
                <span class="viewText" v-else> 统一社会信用代码:{{ form.creditCode }}</span>
              </el-col>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="仓库地址" prop="otherSystemId">
                  <el-input v-model="form.otherSystemId" :disabled="!editMode" style="width: 90%"></el-input>
                </el-form-item>
                <span class="viewText" v-else> 仓库地址:{{ form.otherSystemId }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" prop="manageRangeName" label="经营范围">
                  <el-select v-model="form.manageRangeName" :disabled="!editMode" multiple placeholder="请选择经营范围" filterable :filter-method="getManageRanges" @change="rangeChange" style="width: 100%">
                    <el-option v-for="item in STATIC_ManageRanges" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <span class="viewText" v-else> 经营范围:{{ form.manageRangeName }}</span>
              </el-col>
              <el-col :span="12" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="备注" prop="remark">
                  <el-input v-model="form.remark" :disabled="!editMode" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
                </el-form-item>
                <span class="viewText" v-else> 备注:{{ form.remark }}</span>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="edit-card" style="padding-bottom: 10px">
          <my-button v-if="$route.query.formMode == 1 || $route.query.formMode == 2" class="btn primary" @click="addBankListEvt" type="primary" v-preventReClick>添加银行</my-button>
        </div>
        <div class="edit-card" style="padding-bottom: 10px">
          <el-table ref="multipleTable" :data="form.supplierBankAccountDetails" border stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column label="序号" width="50" align="center" type="index" />
            <el-table-column label="银行账户名称" align="center" prop="name">
              <template slot-scope="scope">
                <el-input v-if="$route.query.formMode == 1 || $route.query.formMode == 2" v-model="scope.row.name" placeholder="请输入银行账户名称" />
                <span v-else>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="银行账户编码" align="center" prop="no">
              <template slot-scope="scope">
                <el-input v-if="$route.query.formMode == 1 || $route.query.formMode == 2" v-model="scope.row.no" placeholder="请输入银行账户编码" />
                <span v-else>{{ scope.row.no }}</span>
              </template>
            </el-table-column>
            <el-table-column label="开户行" align="center" prop="bankName">
              <template slot-scope="scope">
                <el-input v-if="$route.query.formMode == 1 || $route.query.formMode == 2" v-model="scope.row.bankName" placeholder="请输入开户行" />
                <span v-else>{{ scope.row.bankName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="银行账号" align="center" prop="accountNumber">
              <template slot-scope="scope">
                <el-input v-if="$route.query.formMode == 1 || $route.query.formMode == 2" v-model="scope.row.accountNumber" placeholder="请输入银行账号" />
                <span v-else>{{ scope.row.bankName }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">供应商证照信息</span>
          </div>
          <!-- <div style="margin: 20px 0 12px 10px" v-if="activeName=='2'"> -->
          <div style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm1">新增证件</el-button>
          </div>
          <!-- <el-tabs v-model="activeName" style=" margin: 0px 10px;">
            <el-tab-pane label="其它供应商维护" name="1">
              <el-table :data="form.updateDetails" border height="400" style="width: auto;" :row-class-name="tableRowClassName" stripe :header-cell-style="{ background: '#DDEBFF' }">
                <el-table-column label="序号" width="50" fixed="left" align="center" type="index" />
                <el-table-column label="证件名称" width="180" align="center" prop="name" />

                <el-table-column label="证件编号" width="180" align="center" prop="no" />
                <el-table-column label="证件类型" width="200" align="center" prop="categoryName" />
                <el-table-column label="生效日期" align="center" width="150" prop="startDate">
                  <template slot-scope="scope">
                    <span>{{
                                        parseTime(new Date(scope.row.startDate), "{y}-{m}-{d}")
                                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="失效日期" align="center" width="150" prop="endDate">
                  <template slot-scope="scope">
                    <span>{{ parseTime(new Date(scope.row.endDate), "{y}-{m}-{d}") }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="效期状态" align="center" width="80" prop="overdueName"></el-table-column>

                <el-table-column label="审批状态" width="180" align="center" prop="approveStateName" />
                <el-table-column label="启用状态" align="center" width="80">
                  <template slot-scope="scope">
                    <span>{{ scope.row.state == 0 ? "否" : "是" }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="拒绝原因" width="120" align="center" prop="remark" />
                <el-table-column prop="phone" label="证件扫描件" width="200">
                  <template slot-scope="scope">
                    <div v-for="file in scope.row.fileInfos" :key="file.id">
                      <el-button type="text" size="medium" @click.stop="privewImg(file)">{{file.name}}</el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="上传时间" align="center">
                  <template slot-scope="scope">
                    <span>{{
                                            scope.row.createdTime ? parseTime(new Date(scope.row.createdTime)) : ""
                                        }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" align="center" width="150" class-name="small-padding fixed-width">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.approveState == 0" size="mini" type="text" @click="approveEvt(scope.row)">审批</el-button>
                    <el-button size="mini" type="text" @click="DeleEvt(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="其它供应商" name="2"> -->
              <el-table :data="form.details" border height="400" style="width: auto;" stripe :header-cell-style="{ background: '#DDEBFF' }">
                <el-table-column label="序号" width="50" fixed="left" align="center" type="index" />
                <el-table-column v-if="!isMedicine()" :key="'name'" label="证件名称" width="180" align="center" prop="name" />
                <el-table-column  label="证件编号" width="180" :key="'no'" align="center" prop="no" />
                <!-- <el-table-column :label="isMedicine()?'证件名称':'证件类型'" :key="'categoryName'" min-width="200" align="center" prop="name" /> -->

                <el-table-column label="发证日期"  align="center" width="150" prop="startDate">
                  <template slot-scope="scope">
                    <span>{{
                                        parseTime(new Date(scope.row.startDate), "{y}-{m}-{d}")
                                    }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column v-if="isMedicine()" :key="'issueAuthority'" label="发证机关" width="180" align="center" prop="issueAuthority" /> -->

                <el-table-column  :key="'endDate'" label="有效期至" align="center" width="150" prop="endDate">
                  <template slot-scope="scope">
                    <span>{{ parseTime(new Date(scope.row.endDate), "{y}-{m}-{d}") }}</span>
                  </template>
                </el-table-column>
                  <el-table-column  label="是否长期" align="center" width="80">
                  <template slot-scope="scope">
                    <span>{{ scope.row.longTime == 0 ? "否" : "是" }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="!isMedicine()" label="效期状态" align="center" width="80" prop="overdueName"></el-table-column>

                <el-table-column v-if="!isMedicine()" label="启用状态" align="center" width="80">
                  <template slot-scope="scope">
                    <span>{{ scope.row.state == 0 ? "否" : "是" }}</span>
                  </template>
                </el-table-column>
                <el-table-column  label="是否换新证" width="100" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.isNew == 1 ? "是" : "否" }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="!isMedicine()" prop="phone" label="证件扫描件" width="200">
                  <template slot-scope="scope">
                    <div v-for="file in scope.row.fileInfos" :key="file.id">
                      <el-button type="text" size="medium" @click.stop="privewImg(file)">{{file.name}}</el-button>
                      <!-- <el-image-viewer :filePath="file.path" :fileName="file.name" /> -->
                    </div>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="上传单位" align="center" width="120" prop="uploadSupplierName" show-overflow-tooltip></el-table-column> -->
                <el-table-column v-if="!isMedicine()" label="上传时间" align="center">
                  <template slot-scope="scope">
                    <span>{{
                                        scope.row.createdTime ? parseTime(new Date(scope.row.createdTime)) : ""
                                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="isMedicine()" label="备注" align="center" prop="remark" />
                <el-table-column v-if="!isMedicine()" label="拒绝原因" align="center" prop="remark" />
                <el-table-column label="操作" fixed="right" align="center" width="150" :key="'mySuppliersOperate'" class-name="small-padding fixed-width">
                  <template slot-scope="scope">
                    <el-button v-if="!scope.row.uploadSupplierName" size="mini" type="text" @click="supplierEditEvt(scope.row)">编辑</el-button>
                    <el-button v-if="!scope.row.uploadSupplierName &&!isMedicine()" size="mini" type="text" @click="changeNewEvt(scope.row)">换新证</el-button>
                    <!-- <el-button v-if="!scope.row.uploadSupplierName &&title !== '查看'" size="mini" type="text" @click="DeactivateEvt(scope.row)">停用</el-button> -->
                    <el-button size="mini" type="text" @click="DeleEvt(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            <!-- </el-tab-pane>
          </el-tabs> -->
         
        </div>
        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">委托人信息</span>
          </div>
          <div style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="addInfo">新增委托人</el-button>
          </div>

          <el-table ref="multipleTable" :data="form.clientDetail" border stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column label="序号" width="50" fixed="left" align="center" type="index" />
                <el-table-column  label="委托人姓名" min-width="180"   align="center" prop="name" />
                <el-table-column  label="委托人身份证号" min-width="180"  align="center" prop="idCardNumber" />
                <el-table-column  label="身份证有效期" min-width="180"   align="center" prop="validedDate">
                  <template slot-scope="scope">
                    <span>{{ parseTime(new Date(scope.row.validedDate), "{y}-{m}-{d}") }}</span>
                  </template>
                </el-table-column>
                <el-table-column  label="委托书有效期至" min-width="180"   align="center" prop="validedDate1">
                  <template slot-scope="scope">
                    <span>{{ parseTime(new Date(scope.row.validedDate1), "{y}-{m}-{d}") }}</span>
                  </template>

                </el-table-column>
          </el-table>
        </div>


        <el-form-item v-if="$route.query.formMode != 4" label="启用状态">
          <el-switch v-model="form.state" :disabled="!editMode" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
          </el-switch>
          <span v-if="form.state">已启用</span>
          <span v-else>已禁用</span>
        </el-form-item>
      </el-form>
      <!-- <el-image-viewer :openViewer="openViewer" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
    </div>

    <el-dialog title="新增委托人信息" :visible.sync="dialogInfoVisible" width="600px">
      <el-form ref="infoForm" :model="infoForm"  label-width="150px">
        <el-row>
          <el-col :span="18">
            <el-form-item label="委托人姓名" prop="name">
              <el-input v-model="infoForm.name" placeholder="请输入委托人姓名" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="委托人身份证号" prop="no">
              <el-input v-model="infoForm.idCardNumber" placeholder="请输入委托人身份证号" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="身份证有效期" prop="startDate">
              <el-date-picker v-model="infoForm.validedDate" type="date"  placeholder="选择开始日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
        <el-col :span="18">
          <el-form-item label="委托书有效期至" prop="startDate">
            <el-date-picker v-model="infoForm.validedDate1" type="date"  placeholder="选择开始日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
       
      </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="infoClose">取 消</el-button>
          <el-button type="primary" @click="saveInfo">确 定</el-button>
        </div>
    </el-dialog>

    <!-- 新增弹窗（编辑）开始 -->
    <el-dialog v-if="documentOpen" :title="documentTitle" :visible.sync="documentOpen" width="800px" @close="documentClose" append-to-body>

      <el-form ref="documentData" :model="documentData" :rules="addDocumentRules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="category">
              <el-select v-model="documentData.category" style="width: 100%" filterable placeholder="请选择证件类型" @change="categoryDocumentData">
                <el-option v-for="item in  isMedicine()?MedicineSupplierCategoryOptions:SupplierCertificateOptions1" :key="item.value" :label="item.name"  :value="item.value">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
        </el-row>
          <el-row >
          <el-col :span="12">
            <el-form-item label="证件名称" prop="name">
              <el-input v-model="documentData.name" placeholder="请输入证件名称" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件编号" prop="no">
              <el-input v-model="documentData.no" placeholder="请输入证件编号" />
            </el-form-item>
          </el-col>
        </el-row>
      
        <el-row >
          <el-col :span="12">
            <el-form-item label="发证机关" prop="issueAuthority">
              <el-input v-model="documentData.issueAuthority" placeholder="请输入发证机关" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row >
          <el-col :span="14">
            <el-form-item label="发证日期" prop="issueStartDate">
              <el-date-picker
              v-model="documentData.issueStartDate"
              type="date"
              value-format="yyyy-MM-dd"
              @change="issueStartDateChange"
              placeholder="选择发证日期">
            </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
     

        <el-row>
          <el-col :span="14">
            <el-form-item label="有效期至" prop="startDate">
                  <el-date-picker
                  v-model="documentData.endDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                    @change="endDateChange"
                  placeholder="选择有效期至">
                </el-date-picker>
              <!-- <el-date-picker v-model="documentData.startDate" type="date" style="width: 150px" placeholder="选择开始日期" value-format="yyyy-MM-dd">
              </el-date-picker>
              -
              <el-date-picker v-model="documentData.endDate" type="date" style="width: 150px" @change="endDateEvt" placeholder="选择结束日期" value-format="yyyy-MM-dd">
              </el-date-picker> -->
            </el-form-item>
          </el-col>
          <el-col >
            <el-form-item>
              <el-checkbox v-model="documentData.longTime" @change="longTimeEvt">长期</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item  label="启用状态" prop="state">
            <el-radio v-model="documentData.state" :label="1">启用</el-radio>
            <el-radio v-model="documentData.state" :label="0">禁用</el-radio>
          </el-form-item>
        </el-row>
         <el-row>
            <el-form-item  label="备注" prop="remark">
              <el-input :disabled="!editMode" v-model="documentData.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
            </el-form-item>
        </el-row>
        <el-row>
          <el-form-item  label="证件附件" >
            <div style="display: flex; align-items: center">
              <el-upload style="width: 50%" class="upload-demo" ref="upload" :multiple="true" :show-file-list="false" :action="uploadAction" :accept="uploadFileType" :headers="uploadHeaders" :on-success="
                      (response, file, fileList) =>
                        onUploadSuccess(response, file, fileList, 'documentData')
                    ">
                <el-button type="text">点击此处上传附件</el-button>
              </el-upload>
              <el-popover style="width: 50%" placement="bottom" width="360" trigger="click">
                <ul class="fileListUl_always">
                  <li class="fileItem" v-for="(i, k) in documentData.fileInfos" :key="k">
                    <span class="fileName">{{ i.name }}</span>
                    <div class="btn_group canedit">
                      <span v-preventReClick @click="privewImg(i)">
                        点击查看
                      </span>
                      <!-- <span v-preventReClick @click="downloadImg(i)"> 下载 </span> -->
                      <!-- <span v-preventReClick v-if="editMode" @click="RemoveFile(i, scope.row)">
                                            删除
                                        </span> -->
                    </div>
                  </li>
                </ul>
                <span slot="reference" class="show-files">
                  查看附件
                  <i class="el-icon-caret-top"></i>
                </span>
              </el-popover>
            </div>
            <!-- <my-upload :oldFileInfos="documentData.fileInfos" @filesChange="filesChange"></my-upload> -->
          </el-form-item>
        </el-row>
       
      </el-form>
      <!-- <p>注意：图片需加盖机构公章</p> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveDocumentEvt">确定</el-button>
        <el-button @click="documentClose">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 新增弹窗（编辑）结束 -->

    <el-dialog title="换新证" :visible.sync="changeOpen" width="1100px" @close="changeClose" append-to-body>
      <el-row>
        <el-col :span="12">
          <el-form ref="form" :model="documentData" :rules="addDocumentRules" label-width="120px">
            <el-row>
              <el-form-item label="原证件类型">
                <el-select v-model="documentData.category" disabled filterable placeholder="请选择证件类型" style="width: 100%">
                  <el-option v-for="item in SupplierCertificateOptions1" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>

            <el-row>
              <el-form-item label="原证件编号">
                <el-input v-model="documentData.no" disabled placeholder="请输入证件编号" />
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="原证件名称">
                <el-input v-model="documentData.name" disabled placeholder="请输入证件名称" />
              </el-form-item>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="原有效期限">
                  <el-date-picker v-model="documentData.startDate" disabled type="date" style="width: 150px" placeholder="选择开始日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                  -
                  <el-date-picker v-model="documentData.endDate" disabled type="date" style="width: 150px" placeholder="选择结束日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item>
                  <el-checkbox disabled v-model="documentData.longTime">长期</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="原启用状态">
                <el-radio v-model="documentData.state" disabled :key="1" label="1">启用</el-radio>
                <el-radio v-model="documentData.state" disabled :key="0" label="0">禁用</el-radio>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="原证件附件">
                <div style="display: flex; align-items: center">
                  <el-upload style="width: 50%" class="upload-demo" ref="upload" disabled :multiple="true" :show-file-list="false" :action="uploadAction" :accept="uploadFileType" :headers="uploadHeaders" :on-success="
                      (response, file, fileList) =>
                        onUploadSuccess(response, file, fileList, 'documentData' )
                    ">
                    <!-- <el-button type="text">点击此处上传附件</el-button> -->
                  </el-upload>
                  <el-popover style="width: 50%" placement="bottom" width="360" trigger="click">
                    <ul class="fileListUl_always">
                      <li class="fileItem" v-for="(i, k) in documentData.fileInfos" :key="k">
                        <span class="fileName">{{ i.name }}</span>
                        <div class="btn_group canedit">
                          <span v-preventReClick @click="privewImg(i)">
                            点击查看
                          </span>
                          <!-- <span v-preventReClick @click="downloadImg(i)"> 下载 </span> -->
                          <!-- <span v-preventReClick v-if="editMode" @click="RemoveFile(i, scope.row)">
                                            删除
                                        </span> -->
                        </div>
                      </li>
                    </ul>
                    <span slot="reference" class="show-files">
                      查看附件
                      <i class="el-icon-caret-top"></i>
                    </span>
                  </el-popover>
                </div>
              </el-form-item>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form ref="changeData" :model="changeData" :rules="addDocumentRules" label-width="120px">
            <el-row>
              <el-form-item label="证件类型" prop="selectHospitalId">
                <el-select v-model="changeData.category" disabled filterable placeholder="请选择证件类型" style="width: 100%" @change="onTypeChange1">
                  <el-option v-for="item in SupplierCertificateOptions1" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>

            <el-row>
              <el-form-item label="证件编号" prop="no">
                <el-input v-model="changeData.no" placeholder="请输入证件编号" />
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="证件名称" prop="name">
                <el-input v-model="changeData.name" placeholder="请输入证件名称" />
              </el-form-item>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="有效期限" prop="startDate">
                  <el-date-picker v-model="changeData.startDate" type="date" style="width: 150px" placeholder="选择开始日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                  -
                  <el-date-picker v-model="changeData.endDate" type="date" style="width: 150px" @change="endDateEvt1" placeholder="选择结束日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item>
                  <el-checkbox v-model="changeData.longTime" @change="longTimeEvt1">长期</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="启用状态" prop="state">
                <el-radio v-model="changeData.state" :key="1" label="1">启用</el-radio>
                <el-radio v-model="changeData.state" :key="0" label="0">禁用</el-radio>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="证件附件" prop="fileInfos">
                <div style="display: flex; align-items: center">
                  <el-upload style="width: 50%" class="upload-demo" ref="upload" :multiple="true" :show-file-list="false" :action="uploadAction" :accept="uploadFileType" :headers="uploadHeaders" :on-success="
                      (response, file, fileList) =>
                        onUploadSuccess(response, file, fileList, 'changeData')
                    ">
                    <el-button type="text">点击此处上传附件</el-button>
                  </el-upload>
                  <el-popover style="width: 50%" placement="bottom" width="360" trigger="click">
                    <ul class="fileListUl_always">
                      <li class="fileItem" v-for="(i, k) in changeData.fileInfos" :key="k">
                        <span class="fileName">{{ i.name }}</span>
                        <div class="btn_group canedit">
                          <span v-preventReClick @click="privewImg(i)">
                            点击查看
                          </span>
                          <!-- <span v-preventReClick @click="downloadImg(i)"> 下载 </span> -->
                          <!-- <span v-preventReClick v-if="editMode" @click="RemoveFile(i, scope.row)">
                                            删除
                                        </span> -->
                        </div>
                      </li>
                    </ul>
                    <span slot="reference" class="show-files">
                      查看附件
                      <i class="el-icon-caret-top"></i>
                    </span>
                  </el-popover>
                </div>
              </el-form-item>
            </el-row>
          </el-form>
          <p>注意：图片需加盖机构公章</p>
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveChangeEvt">确定</el-button>
        <el-button @click="changeOpen = false">取 消</el-button>
      </div>
    </el-dialog>

    <div slot="footer" class="footer-bottom">
      <el-button class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button class="btn primary" type="primary" v-if="editMode" v-preventReClick @click="submit">确 定</my-button>
    </div>
    <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" />
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetSupplierById,
  SaveSupplier,
  SaveSupplierCertDetail,
  UpdateSupplierCertDetail,
  RemoveSupplierCertDetail,
  ApproveSupplierCertDetail,

} from "@/api";
import {
  SupplierCategoryOptions,
  LevelOptions,
  SupplierCertificateOptions1,
  MedicineSupplierCategoryOptions,
} from "@/enum";
import Address from "@/components/address";
import MyUpload from "@/components/my-upload";
import ElImageViewer from "@/components/elImageViewer";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {
    Address,
    MyUpload,
    ElImageViewer,
  },
  data () {
    return {
      title: "",
      form: {},
      SupplierCategoryOptions: SupplierCategoryOptions,
      LevelOptions: LevelOptions,
      SupplierCertificateOptions1: SupplierCertificateOptions1,
      MedicineSupplierCategoryOptions:MedicineSupplierCategoryOptions,
      rules: {
        name: [{
          required: true,
          message: "供应商名称不能为空",
          trigger: "blur",
        },],
        category1: [{
          required: true,
          message: "供应商类型不能为空",
          trigger: "blur",
        },],
        creditCode: [{
          required: true,
          message: "社会信用代码不能为空",
          trigger: "blur",
        },],
        contactor: [{
          required: true,
          message: "联系人不能为空",
          trigger: "blur",
        },],
        phone: [{
          required: true,
          message: "联系电话不能为空",
          trigger: "blur",
        },
          // {
          //   pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          //   message: "请输入正确的手机号码",
          //   trigger: "blur",
          // },
        ],
      },
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      fileId: 0,
      fileName: "",
      openViewer: false,
      countryId: "",
      provinceId: "",
      cityId: "",
      dialogVisible: false,
      dialogImageUrl: "",
      fileName: "",
      fileId: 0,
      timeStamp: "",
      editMode: false,
      activeName: '1',
      //
      documentOpen: false,
      documentTitle: "新增",
      documentList: [],
      documentData: {
        category: '',
        state: 1,
        name:''
      },
      addDocumentRules: {
        category: [{
          required: true,
          message: "请选择证件类型",
          trigger: "blur"
        },],
        no: [{
          required: true,
          message: "请输入证件编号",
          trigger: "blur"
        },],
        name: [{
          required: true,
          message: "请输入证件名称",
          trigger: "blur"
        },],
        startDate: [{
          required: true,
          message: "请选择原有效期限",
          trigger: "blur"
        },],
        state: [{
          required: true,
          message: "请选择原启用状态",
          trigger: "blur"
        },],
        issueAuthority:[{
          required: true,
          message: "请输入发证机关",
          trigger: "blur"
        }],        
        issueStartDate:[{
          required: true,
          message: "请选择发证日期",
          trigger: "blur"
        }],
        fileInfos: [{
          required: true,
          message: "证件附件不能为空",
          trigger: "blur",
        },],
      },
      changeOpen: false,
      changeData: {},
      dialogInfoVisible: false,
      infoForm:{},
    };
  },
  props: {
    // title: {
    //   type: String,
    //   default () {
    //     return ''
    //   }
    // }
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    if (query.formMode == 0) {
      this.title = "查看";
    } else if (query.formMode == 2) {
      this.title = "编辑";
    }
    this.getManageRanges("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetSupplierById({
        id,
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.countryId = this.form.countryId;
        this.provinceId = this.form.provinceId;
        this.cityId = this.form.cityId;
        let arr =  this.form.categories?.split(';')
       
        this.form.category1 = arr?.map(Number)
        // this.title = "编辑";
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
        
        this.editMode = false;
        if (this.formMode == 2) {
          this.editMode = true;
        }
        if (this.form.manageRangeInfos) {
          let arr = this.form.manageRangeInfos.map((item) => {
            var range = this.STATIC_ManageRanges.filter((e) => e.id == item.id);
            if (!range || range.length == 0) {
              this.STATIC_ManageRanges.push(item);
            }

            return item.id * 1;
          });
          this.$set(this.form, "manageRangeName", [...arr]);
        }
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.form.countryId = this.countryId || 0;
        this.form.provinceId = this.provinceId || 0;
        this.form.cityId = this.cityId || 0;

        SaveSupplier(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(
            this.getMainPath(this.$route.path),
            this.$route.params
          );
        });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        state: 1,
        countryId: 0,
        provinceId: 0,
        category1:[],
        cityId: 0,
        details: [],
        otherSystemId: "",
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.push({ path: this.getMainPath(this.$route.path) });
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },
    handleAddChildForm () {
      if (!this.form.details) this.form.details = [];
      this.form.details.push({
        $index: this.form.details.length + 1,
        id: 0,
        categoryName: "",
        fileInfos: [],
        stateName: "",
        no: "",
        category: 1,
        certificateName: "",
        startDate: "",
        endDate: "",
        files: "",
        remark: "",

      });
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    changeEndDate (row) {
      row.endDate = "2099-12-31";
    },
    dateChange (row) {
      if (row.startDate && row.endDate) {
        // if (
        //   new Date(row.startDate) < new Date() &&
        //   new Date(row.endDate) >= new Date()
        // ) {
        //   row.stateName = "正常";
        // } else {
        //   row.stateName = "过期";
        // }
        if (new Date(row.endDate) < new Date()) {
          row.stateName = "过期";
        } else {
          row.stateName = "正常";
        }
      }
    },
    addInfo(){
      this.dialogInfoVisible = true
    },
    infoClose(){
      this.dialogInfoVisible = false
      this.infoForm= {}
    },
    saveInfo(){
      this.form.clientDetail = this.infoForm.clientDetail??[]
      this.form.clientDetail.push(this.infoForm)
      this.dialogInfoVisible = false
    },
  
    categoryDocumentData(val){
      let arr = this.isMedicine()?this.MedicineSupplierCategoryOptions:this.SupplierCertificateOptions1;
      let obj = arr.find(item=>item.value == val)
      this.documentData.categoryName = obj.name
      this.documentData.name = obj.name
      this.documentData.category = val
      
    },
    rangeChange (val) {
      this.form["manageRangeId"] = val ? val.join(";") : "";
    },
    getAddressData (countryId, provinceId, cityId) {
      this.countryId = countryId;
      this.provinceId = provinceId;
      this.cityId = cityId;
    },

    // 上传附件
    onUploadSuccess (response, file, fileList, row) {
      response.returnData.forEach((item) => {
        if (!this[row].fileInfos) {
          this[row].fileInfos = []
        }
        this[row].fileInfos.push(item);
      });
      console.log(this[row],);
      
      console.log(this[row].fileInfos);
      this.$forceUpdate()
      this.timeStamp = new Date().valueOf();
    },
    privewImg (file) {
      // this.dialogImageUrl = file.path;
      // this.dialogVisible = true;
      this.dialogVisible = true;
      this.fileId = file.id;
      this.fileName = file.name;
    },
    closeImageViewer () {
      this.dialogVisible = false;
    },
    RemoveFile (file, row) {
      var index = row.fileInfos.indexOf(file);
      if (index > -1) {
        row.fileInfos.splice(index, 1);
      }
    },

    endDateDisabledDate (v, row) {
      if (row.startDate) {
        return v.getTime() < new Date(row.startDate).getTime();
      } else {
        return false;
      }
    },
    addBankListEvt () {
      if (this.form.supplierBankAccountDetails == undefined) {
        this.form.supplierBankAccountDetails = [];
      }
      this.form.supplierBankAccountDetails.push({});
      this.$set(
        this.form,
        this.form.supplierBankAccountDetails,
        this.form.supplierBankAccountDetails
      );
    },
    handleAddChildForm1 () {
      this.documentOpen = true
    },
    changeNewEvt (row) {
      this.documentData = JSON.parse(JSON.stringify(row));
      this.documentData.state = row.state
      this.changeData.category = this.documentData.category;
      this.$set(this.changeData, "name", this.documentData.name);
      this.changeData.oldId = this.documentData.id;
      // this.changeData.name =
      this.changeOpen = true;
    },
    longTimeEvt (boolean) {
      if (boolean == true) {
        this.documentData.endDate = null;
      }
    },
    longTimeEvt1 (boolean) {
      if (boolean == true) {
        this.changeData.endDate = null;
      }
    },
    onTypeChange (val) {
      let arr = this.SupplierCertificateOptions1.filter((res) => res.value == val);
      this.documentData.categoryName = arr[0].name;
    },
    onTypeChange1 (val) {
      let arr = this.SupplierCertificateOptions1.filter((res) => res.value == val);
      this.changeData.categoryName = arr[0].name;
    },
    endDateEvt () {
      this.documentData.longTime = false;
    },
    endDateEvt1 () {
      this.changeData.longTime = false;
    },
    documentClose () {
      this.documentData = {
        category: '',
        longTime: false,
        state: 1,
        fileInfos: [],
        name:''
      };
      this.documentOpen = false;
      this.$forceUpdate();
    },
    changeClose () {
      this.changeData = {
        category: '',
        longTime: false,
        state: 1,
        fileInfos: []
      };
    },
    endDateChange(){
      this.$forceUpdate()
    },
    isMedicine(){      
      let categories = this.form.category1??[]
      const targetNumbers = [5, 6, 7];
      const hasTarget = targetNumbers.some(num => categories.includes(num));
      return hasTarget;
    },
    // isRoMedicine(){
    //   let categories = this.form.category1??[]
    //   const targetNumbers = [5, 6, 7];
    //   const hasTarget = targetNumbers.some(num => categories.includes(num));
    //   const onlyHasTarget = categories.length > 0 && categories.every(num => targetNumbers.includes(num));
    //   let arr = []

    //   if (onlyHasTarget) {
    //     arr = this.MedicineSupplierCategoryOptions
    //   } else if (hasTarget) {
    //     arr = this.SupplierCertificateOptions1
    //   } else {
    //     arr = this.SupplierCertificateOptions1
    //   }
    //   return arr
    // },
    categoryChange(val){
      const targetNumbers = [5, 6, 7];
      const hasTarget = targetNumbers.some(num => val.includes(num));
      if (hasTarget) {
        // 这里可以添加你需要执行的其他逻辑
      this.getManageRanges("",4);
      }else{
        this.getManageRanges("");
      }
      this.form.categories = val.join(';')

      this.isMedicine()
      
      this.$forceUpdate()
    },
    saveDocumentEvt () {
      this.$refs.documentData.validate((valid) => {
        if (valid) {
          this.documentData.longTime = this.documentData.longTime == true ? 1 : 0;
          this.documentData.parentId = this.form.id
          this.documentData.isNew = 0
          this.documentData.type = 1
          if(!this.form.id){
            this.form.details = this.form.details??[]
            this.form.details.push(this.documentData)
            this.documentOpen = false;
            return

          }
          SaveSupplierCertDetail(this.documentData).then((res) => {
              this.handleUpdate(this.form.id);
            this.documentOpen = false;
          });
        }
      });
    },
    issueStartDateChange(val){
      this.documentData.startDate = val
    },
    saveChangeEvt () {
      this.$refs.changeData.validate((valid) => {
        if (valid) {
          this.changeData.longTime = this.changeData.longTime == true ? 1 : 0;
          this.changeData.parentId = this.documentData.parentId;
          this.changeData.oldId = this.documentData.id;
          this.changeData.type = 1
          UpdateSupplierCertDetail(this.changeData).then((res) => {
            this.handleUpdate(this.form.id);
            this.changeOpen = false;
          });
        }
      });
    },
    tableRowClassName ({
      row,
      rowIndex
    }) {
      if (this.$route.query.detailId) {
        if (row.id == this.$route.query.detailId) {
          return 'warning-row';
        }
      }

    },
    //审批
    approveEvt (row) {
      this.$prompt("请输入拒绝理由", "审批", {
        distinguishCancelAndClose: true,
        confirmButtonText: '拒绝',
        confirmButtonClass: 'refuse',
        cancelButtonClass: 'pass',
        cancelButtonText: '通过',
      })
        .then(({
          value
        }) => {
          ApproveSupplierCertDetail({
            id: row.id,
            result: 0,
            reason: value,
          }).then((res) => {
            this.handleUpdate(this.form.id);

          });
        })
        .catch((action, value) => {
          console.log(this.$prompt.inputValue);
          if (action == "cancel") {
            ApproveSupplierCertDetail({
              id: row.id,
              result: 1,
            }).then((res) => {
              this.handleUpdate(this.form.id);
            });
          } else {
            return;
          }
        });
    },
    categoryEvt (val) {
      console.log(val);
      this.documentData.category = val
    },
    DeleEvt (row) {
      this.$confirm("删除后将无法恢复，请谨慎操作。", "确定要删除吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          RemoveSupplierCertDetail({
            id: row.id
          }).then((res) => {
            this.handleUpdate(this.form.id);
          });
        })
        .then(() => {
          this.msgSuccess("删除成功");
        })
        .catch(function () { });
    },
    supplierEditEvt (row) {
      row.state = row.state.toString();
      this.documentData = JSON.parse(JSON.stringify(row));
      if (row.longTime == 1) {
        this.documentData.longTime = true;
      } else {
        this.documentData.longTime = false;
      }
      this.documentName = '编辑证件'
      this.documentOpen = true;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-table .warning-row {
  background: oldlace;
}
</style>
